import { render, staticRenderFns } from "./crypto-payconfig-add-or-update.vue?vue&type=template&id=6c718848"
import script from "./crypto-payconfig-add-or-update.vue?vue&type=script&lang=js"
export * from "./crypto-payconfig-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports